module.exports = __webpack_public_path__ + "static/media/img-2.03f4858d.jpg";